
































import { goHome } from "../services";
import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class CreateDialog extends Vue {
  @Prop() dialog!: boolean;
  @Prop() winner!: string;
  @Prop() first!: string;
  @Prop() firstWPM!: string;
  @Prop() second!: string;
  @Prop() secondWPM!: string;
  onConfirm = goHome;
}
